import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Medya yükleme: Cloudflare R2 + Worker (firebase.storage kullanılmaz).
const firebaseConfig = {
  apiKey: 'AIzaSyBP4Ic3eBTnPvSM9RkZcORBgg6hi1Q3f08',
  authDomain: 'jigogo.firebaseapp.com',
  projectId: 'jigogo',
  storageBucket: 'jigogo.firebasestorage.app',
  messagingSenderId: '896646469602',
  appId: '1:896646469602:web:8adedfc0c2fe2474220bbb',
  measurementId: 'G-Y920H98D5V',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

export { app };
export default app;
